import { render, staticRenderFns } from "./BoxSlider.vue?vue&type=template&id=4c0e7638&scoped=true&"
import script from "./BoxSlider.vue?vue&type=script&lang=ts&"
export * from "./BoxSlider.vue?vue&type=script&lang=ts&"
import style0 from "./BoxSlider.vue?vue&type=style&index=0&id=4c0e7638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e7638",
  null
  
)

export default component.exports